import React, {Component} from 'react'
import { withApollo } from 'react-apollo'
import { Tabs, Typography, Spin, Row, Col, Input, message, Button, Form, Table, Modal } from 'antd'
import { Queries, Mutations } from '../../../../../graphql'
import Container from '../../../../../components/user/Container'
import FormInputAddress from '../../../../../components/user/FormInputAddress'
import TabsBlockProFile from '../../../../../components/user/TabsBlockProFile'
import { datasetsProfileDetail, tabProfile } from '../../../../../config/datasetsProfile'
import { checkType } from '../../../../../utils/checkType'
import { pushAge } from '../../../../../utils/formatdate'
import moment from 'moment'
import { changeFormatdate, changeFormatFullDateTime, changeFormatdateThai, changeFormatMonthYearThai } from '../../../../../utils/formatdate'
import { numberWithCommas } from '../../../../../utils/number'

const { TabPane } = Tabs
const { Text, Title } = Typography

const newsDataProfile = '';

const formItemLayout = {
	labelCol: {
	  xs: { span: 24 },
	  sm: { span: 8 },
	},
	wrapperCol: {
	  xs: { span: 24 },
	  sm: { span:16 },
	},
  };

class condition1 extends Component {
	state = {
		dataTableChangProvidentFund:[],
        columnsProvidentFund:[
            {
                title: 'วันที่แก้ไข',
                dataIndex: 'modifiedDate',
                width:'100',
                align:'center',
                vertical:'top',
                render: (item, record, index) => <span>{ changeFormatFullDateTime(item)}</span>
            },
            {
                title: 'ชื่อผู้แก้ไข',
                dataIndex: 'modifiedDate',
                width:'100',
                align:'center',
                vertical:'top',
                render: (item, record, index) => <span>{ '-' }</span>
            },
            {
                title: 'อัตราหักเงินสะสมทบ',
                dataIndex: 'provEmployeeDeduct',
                width:'100',
                align:'center',
                vertical:'top',
                render: (item, record, index) => <span>{item.toFixed(2)}</span>
            },
            {
                title: 'อัตราหักเงินสะสม',
                dataIndex: 'provEmployerDeduct',
                width:'100',
                align:'center',
                vertical:'top',
                render: (item, record, index) => <span>{item.toFixed(2)}</span>
            },
            {
                title: 'นโยบายการลงทุน',
                dataIndex: 'providentFundName',
                width:'100',
                align:'center',
                vertical:'top',
                render: (item, record, index) => <span>{ item ? item : '-' }</span>
            },
            {
                title: 'หมายเหตุ',
                dataIndex: 'providentFundName',
                width:'100',
                align:'center',
                vertical:'top',
                render: (item, record, index) => <>
                    {
                        item ?
                            <span 
                                onClick={()=>{this.showModalNode(item)}} 
                                style={{ cursor:"pointer" }}
                                className="btn-show-fileuploads"
                            > 
                                อ่านหมายเหตุ
                            </span>
                        : '-'
                    }
                
                </>
            },
        ],
        dataTableChangPeopleFund:[],
        columnsPeopleFund:[
            {
                title: 'คนที่',
                dataIndex: 'listNo',
                width:'100',
				align:'center',
                vertical:'top',
                render: (item, record, index) => <span>{ item }</span>
            },
            {
                title: 'ชื่อ - นามสกุล',
                dataIndex: 'benefitsName',
                width:'100',
				align:'center',
                vertical:'top',
                render: (item, record, index) => <div align={"left"}>{ item }</div>
            },
            {
                title: 'เลขที่บัตรประชาชน',
                dataIndex: 'benefitsIdCard',
                width:'100',
				align:'center',
                vertical:'top',
                render: (item, record, index) => <span>{ item ? item : '-' }</span>
            },
            {
                title: 'เปอร์เซ็นต์ที่ได้รับ',
                dataIndex: 'benefitsRate',
                width:'100',
				align:'center',
                vertical:'top',
                render: (item, record, index) => <span>{ item.toFixed(2) }</span>
            }
        ],
        modalCondition1: false,
        modalCondition2: false,
        showModalNote: false,
        noteModal: null,
        dataTableSessionHistory:[
            // {
            //     provEmployeeDeduct: 5,
            //     modifiedDate: moment(),
            // }
        ],
        columnsSessionHistory:[
            {
                title: 'ประเภทการแก้ไข',
                dataIndex: 'provEmployeeDeduct',
                width:'100',
				align:'center',
                vertical:'top',
                render: (item, record, index) => <span>เปลี่ยนแปลง % สะสม</span>
            },
            {
                title: 'วันที่แก้ไข',
                dataIndex: 'modifiedDate',
                width:'100',
				align:'center',
                vertical:'top',
                render: (item, record, index) => <span>{ changeFormatFullDateTime(item)}</span>
            },
            {
                title: 'วันที่ส่งไป HRMI',
                dataIndex: 'provEmployeeDeduct',
                width:'100',
				align:'center',
                vertical:'top',
                render: (item, record, index) => <span>-</span>
            },
            {
                title: 'สถานะ',
                dataIndex: 'provEmployeeDeduct',
                width:'100',
				align:'center',
                vertical:'top',
                render: (item, record, index) => <span>แบบร่าง</span>
            },
            {
                title: 'ผู้ดำเนินการ',
                dataIndex: 'provEmployeeDeduct',
                width:'100',
				align:'center',
                vertical:'top',
                render: (item, record, index) => <div align={"left"}>
                                                        { this.props.profile.title+' '+this.props.profile.firstName+' '+this.props.profile.lastName }
                                                    </div>
            },
			{
                title: 'รายละเอียด',
                dataIndex: 'provEmployeeDeduct',
                width:'100',
				align:'center',
                vertical:'top',
                render: (item, record, index) => <>
                    {
                        item ?
                            <span 
                                onClick={()=>{this.showModalNodeSession(record)}} 
                                style={{ cursor:"pointer" }}
                                className="btn-show-fileuploads"
                            > 
                                ดูรายละเอียด
                            </span>
                        : '-'
                    }
                
                </>
            },
           
        ],
        showModalNoteSession: false,
        noteModalSession: null,
        configDataProvPercentage: null,
	}

     showModalNodeSession = async (record) => {
        const { configDataProvPercentage } = this.state
        // let noteModal = ''
        record.summarySalary = ( parseFloat(configDataProvPercentage.salary) * record.provEmployeeDeduct) / 100
        
        await this.setState({
            showModalNoteSession: true,
            noteModalSession: record,
            // titleNoteModal: "รายละเอียด"
        });
    };


    showModalNode = (item) => {
        this.setState({
            showModalNote: true,
            noteModal:item
        });
    };
    showModalCondition1 = async () =>{
        await this.setState({
            modalCondition1: true
        })
    }

    hideModalCondition1 = async () =>{
        await this.setState({
            modalCondition1: false
        })
    }

    showModalCondition2 = async () =>{
        await this.setState({
            modalCondition2: true
        })
    }

    hideModalCondition2 = async () =>{
        await this.setState({
            modalCondition2: false
        })
    }

    fetchConfigChangeProvPercentage = async () =>{
		const { client, location } = this.props

		const { data, errors } = await client.query({
			query: Queries.fetchConfigChangeProvPercentage,
		})

        if(data.fetchConfigChangeProvPercentage){
            await this.setState({
                configDataProvPercentage: data.fetchConfigChangeProvPercentage,
                dataTableSessionHistory: data.fetchConfigChangeProvPercentage.provRateHistory
            })
        }
	}


	async componentDidMount(){
        await this.fetchConfigChangeProvPercentage()
    }

	render() {
		const { history, location, match, staticContext, dataForm } = this.props
		const { 
                dataTableChangProvidentFund, 
                columnsProvidentFund, 
                columnsPeopleFund, 
                dataTableChangPeople,
                modalCondition1,
                modalCondition2,
                showModalNote,
                noteModal,
                dataTableSessionHistory,
                columnsSessionHistory,
                showModalNoteSession,
                configDataProvPercentage,
                noteModalSession
            } = this.state
		return (
			<div className="px-5 py-1 card-bg-green">
                <Modal
                    visible={showModalNote}
                    title={"หมายเหตุ"}
                    // onOk={this.handleOk}
                    onCancel={ async()=>{
                        await this.setState({
                            showModalNote:false
                        })
                    }}
                    footer={[]}
                >
                    <div  dangerouslySetInnerHTML={{ __html: noteModal }} />
                </Modal>

                <Modal
                    visible={showModalNoteSession}
                    // visible={true}
                    title={"ดูรายละเอียด"}
                    width={800}
                    // onOk={this.handleOk}
                    onCancel={ async()=>{
                        await this.setState({
                            showModalNoteSession:false
                        })
                    }}
                    footer={[]}
                >
                    <Form {...formItemLayout} >
                        <Form.Item label="เงินเดือน" labelAlign="left" className="mb-1">
                            <Input className="w-50 mr-4" disabled={true} value={configDataProvPercentage ? numberWithCommas(configDataProvPercentage.salary) : ''}/>
                            <span className="ant-form-text">บาท</span>
                        </Form.Item>

                        <Form.Item label="หักเงินสะสมร้อยละ" labelAlign="left" className="mb-1">
                            <Input 
                                className="w-50 mr-4" 
                                disabled={true}
                                value={noteModalSession ? numberWithCommas(noteModalSession.provEmployeeDeduct) : ''}
                            />
                        </Form.Item>

                        <Form.Item label="การหักรายได้ต่อเดือน" labelAlign="left" className="mb-1">
                            <Input 
                                className="w-50 mr-4" 
                                disabled={true}
                                value={noteModalSession ? numberWithCommas(noteModalSession.summarySalary) : ''}
                            />
                        </Form.Item>

                        <Row className="mt-3">
                            <Col>
                                <strong>
                                    เงือนไข
                                </strong>
                                <ol>
                                    <li>
                                        สามารถเปลี่ยนแปลงการหักเงินสะสมได้ตั้งแต่วันที่ {configDataProvPercentage ? changeFormatdate(configDataProvPercentage.provChangeDateFrom) : ''} ถึง  {configDataProvPercentage ? changeFormatdate(configDataProvPercentage.provChangeDateTo) : ''}
                                    </li>
                                    <li>
                                        สามารถเปลี่ยนแปลงการหักเงินสะสมร้อยละ 
                                        <span className="mx-1">{ configDataProvPercentage ? numberWithCommas(configDataProvPercentage.changeMin) : '' }</span>
                                        และ สูงสุดไม่เกินร้อยละ 
                                        <span className="mx-1">{ configDataProvPercentage ? numberWithCommas(configDataProvPercentage.changeMax) : '' }</span>
                                    </li>
                                    <li>
                                        การเปลี่ยนแปลงเงินสะสมจะมีผลวันที่ {configDataProvPercentage ? changeFormatdate(configDataProvPercentage.providentFundEffectiveDate) : ''} 
                                    </li>
                                </ol>
                            </Col>
                        </Row>
                    </Form>
                </Modal>

                <Row gutter={16} type="flex" justify="left" align="top" className="box-color-white mx-0" style={{ borderRadius:"0" }}>
                    <Col xs={24} md={24} className="pt-2 mb-3">
                        <strong className="color-red">
                            ข้อมูลกองทุน
                        </strong>
                    </Col>
                    <Col xs={24} md={12} className="pt-2">
                        <Form.Item label={'สถานะการเป็นสมาชิก'} className="mb-0">
                            <Input disabled={true} value={dataForm.employeeFundPolicy.memberStatus || dataForm.employeeFundPolicy.memberStatus == 0 ? dataForm.employeeFundPolicy.memberStatus : '-'} />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={12} className="pt-2">
                        <Form.Item label={'วันที่เริ่มเป็นสมาชิก'} className="mb-0">
                            <Input disabled={true} value={dataForm.employeeFundPolicy.provStartDate || dataForm.employeeFundPolicy.provStartDate == 0 ? changeFormatdate(dataForm.employeeFundPolicy.provStartDate) : '-'}/>
                        </Form.Item>
                    </Col>
                    
                    <Col xs={24} md={12} className="pt-2">
                        <Form.Item label={'ลูกจ้างหักเงินสะสมร้อยละ'} className="mb-0">
                            <Input disabled={true} value={dataForm.employeeFundPolicy.provEmployeeDeduct || dataForm.employeeFundPolicy.provEmployeeDeduct == 0 ? dataForm.employeeFundPolicy.provEmployeeDeduct.toFixed(2) : '-' } />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={12} className="pt-2">
                        <Form.Item label={'นายจ้างหักเงินสะสมร้อยละ'} className="mb-0">
                            <Input disabled={true} value={dataForm.employeeFundPolicy.provEmployerDeduct || dataForm.employeeFundPolicy.provEmployerDeduct == 0 ? dataForm.employeeFundPolicy.provEmployerDeduct.toFixed(2) : '-' } />
                        </Form.Item>
                    </Col>
                    
                    <Col xs={24} md={12} className="pt-2">
                        <Form.Item label={'นโยบายการลงทุน'} className="mb-0">
                            <Input disabled={true} value={dataForm.employeeFundPolicy.fundPolicyName || dataForm.employeeFundPolicy.fundPolicyName == 0 ? dataForm.employeeFundPolicy.fundPolicyName : '-'} />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={12} className="pt-2">
                        <Form.Item label={'นโยบายตราสารหนี้ (F) ร้อยละ'} className="mb-0">
                            <Input disabled={true} value={dataForm.employeeFundPolicy.policyFixedRate || dataForm.employeeFundPolicy.policyFixedRate == 0 ? dataForm.employeeFundPolicy.policyFixedRate.toFixed(2) : '-' } />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={12} className="pt-2">
                        <Form.Item label={'นโยบายตราสารทุน (E) ร้อยละ'} className="mb-0">
                            <Input disabled={true} value={dataForm.employeeFundPolicy.policyEquityRate || dataForm.employeeFundPolicy.policyEquityRate == 0 ? dataForm.employeeFundPolicy.policyEquityRate.toFixed(2) : '-' } />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={12} className="pt-2">
                        <Form.Item label={'นโยบายผสม (M) ร้อยละ'} className="mb-0">
                            <Input disabled={true} value={dataForm.employeeFundPolicy.policyMixRate || dataForm.employeeFundPolicy.policyMixRate == 0 ? dataForm.employeeFundPolicy.policyMixRate.toFixed(2) : '-'} />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={12} className="pt-2">
                        <Form.Item label={'เงินสบทบกรณีออกจากกองทุน'} className="mb-0">
                            <Input disabled={true} value={dataForm.employeeFundPolicy.provEndAmount || dataForm.employeeFundPolicy.provEndAmount == 0 ? dataForm.employeeFundPolicy.provEndAmount.toFixed(2) : '-'} />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={12} className="pt-2">
                        <Form.Item label={'วันสิ้นสุดการเป็นสมาชิก'} className="mb-0">
                            <Input disabled={true} value={dataForm.employeeFundPolicy.provEndDate || dataForm.employeeFundPolicy.provEndDate == 0 ? changeFormatdate(dataForm.employeeFundPolicy.provEndDate) : '-'}/>
                        </Form.Item>
                    </Col>

                    <Col xs={24} md={24} className="mt-4"> 
                        หมายเหตุ : เงินสมทบกรณีออกจากกองทุน จะได้รับเมื่อสิ้นสุดการเป็นบุคลากร สภากาชาดไทย
                    </Col>
                </Row>

                <Row gutter={16} type="flex" justify="left" align="top" className="box-color-white mx-0" style={{ borderRadius:"0" }}>
                    <Col xs={24} md={12} className="pt-2 mb-3">
                        <strong className="color-red">
                        ข้อมูลผู้รับผลประโยชน์
                        </strong>
                    </Col>
                    <Col md={24}>
                        <Table
                            locale={{ emptyText: 'ไม่พบข้อมูลรายการ' }} 
                            dataSource={dataForm.providentFundBenefitsPerson ? dataForm.providentFundBenefitsPerson.benefitsPerson : []} 
                            columns={columnsPeopleFund}
                        />
                    </Col>
                </Row>

                <Row gutter={16} type="flex" justify="left" align="top" className="box-color-white mx-0" style={{ borderRadius:"0" }}>
                    <Col md={24}>
                        <Row>
                            <Col>
                                <strong className="color-red">
                                    ประวัติการเปลี่ยนแปลงข้อมูลกองทุนสำรองเลี้ยงชีพ
                                </strong>
                            </Col>
                            <Col className="mt-3">
                                <Table
                                    locale={{ emptyText: 'ไม่พบข้อมูลรายการ' }} 
                                    dataSource={dataTableSessionHistory} 
                                    columns={columnsSessionHistory}
                                    // loading={preLoadTable}
                                />
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
		)
	}
}

condition1.propTypes = {
	//
}

export default withApollo(condition1)
